import * as React from 'react'
import { connect } from 'react-redux'

import { MultiProductState } from 'embed/reducers'
import { uiSelectedMortgageStepSelector } from 'embed/selectors/ui'
import { MortgageStep } from 'even-ts-static'
import { Mortgage } from './index'

interface Props {
  selectedStep: MortgageStep
}

const Container: React.FC<Props> = ({ selectedStep }) => <Mortgage selectedStep={selectedStep} />

const mapStateToProps = (state: MultiProductState) => ({
  selectedStep: uiSelectedMortgageStepSelector(state),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(Container)
